<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useProjectSettingsModalStore } from '~/stores/project-settings-modal-store';
import { useUserStore } from '~/stores/user-store';
import type { Project } from '~/utilities/pyscript-api-models';

const props = defineProps<{
  project: Project;
  clickHandler: (...args: any) => void;
}>();

const { t } = useI18n();
const userStore = useUserStore();
const projectSettingsModalStore = useProjectSettingsModalStore();
const isProjectOwner = computed(() => userStore.isProjectOwner(props.project));
</script>

<template>
  <div class="relative flex h-5 flex-nowrap gap-2 truncate">
    <button
      v-if="project.tags.length === 0 && isProjectOwner"
      class="pointer-events-auto relative max-w-full whitespace-nowrap rounded-full bg-new-gray-100/60 px-2 py-0.5 text-xs font-normal text-gray-700 transition-colors hover:bg-new-gray-100 dark:bg-new-gray-300 hover:dark:bg-new-gray-400"
      @click="projectSettingsModalStore.open(props.project, 0)"
    >
      {{ t('buttons.add_tag') }}
    </button>

    <button
      v-for="tag in project.tags"
      v-else
      :key="tag"
      class="pointer-events-auto max-w-full whitespace-nowrap rounded-full bg-new-green-600/80 px-2 py-0.5 text-xs font-normal text-gray-800 hover:bg-new-green-700 dark:bg-new-green-700 hover:dark:bg-new-green-600"
      @click="clickHandler(tag)"
    >
      {{ tag }}
    </button>

    <!-- Faded gradient for overflowed items -->
    <div
      class="pointer-events-none absolute bottom-0 right-0 top-0 w-4 bg-gradient-to-l from-white from-10% group-hover:from-new-gray-50 dark:from-gray-675 group-hover:dark:from-new-gray-900"
    />
  </div>
</template>

<style scoped lang="postcss"></style>
